// Shared full-width hobbies grid.

import React from "react";
import {
  generalHobbyOptions,
  spiritualActivityOptions,
} from "../config/hobbyOptions";

import {
  designClasses,
} from "../styles/designTokens";

const FullWidthHobbiesGrid = ({
  label = "Hobbies",
  fieldName,
  formData,
  handleChange,
}) => {
  const normalizeHobbyValue = (value) => {
    if (
      typeof value === "object" &&
      value !== null
    ) {
      return String(
        value.label ??
          value.value ??
          value.name ??
          ""
      ).trim();
    }

    return String(value ?? "").trim();
  };

  const current = Array.isArray(
    formData?.[fieldName]
  )
    ? formData[fieldName]
        .map(normalizeHobbyValue)
        .filter(Boolean)
    : [];

  const isSelected = (itemLabel) =>
    current.some(
      (value) =>
        value.toLowerCase() ===
        itemLabel.toLowerCase()
    );

  const toggle = (itemLabel) => {
    const selected =
      isSelected(itemLabel);

    const next = selected
      ? current.filter(
          (value) =>
            value.toLowerCase() !==
            itemLabel.toLowerCase()
        )
      : [...current, itemLabel];

    const uniqueValues = [
      ...new Map(
        next.map((value) => [
          value.toLowerCase(),
          value,
        ])
      ).values(),
    ];

    handleChange({
      target: {
        name: fieldName,
        value: uniqueValues,
      },
    });
  };

  const renderGroup = (
    heading,
    options
  ) => (
    <div>
      <div
        className={`mb-2 text-sm font-semibold ${designClasses.textPrimary}`}
      >
        {heading}
      </div>

      <div className="flex flex-wrap gap-2">
        {options.map((option, index) => {
          const itemLabel =
            normalizeHobbyValue(option);
          const selected =
            isSelected(itemLabel);

          return (
            <button
              key={`${itemLabel}-${index}`}
              type="button"
              aria-pressed={selected}
              onClick={() =>
                toggle(itemLabel)
              }
              className={`rounded-full border px-3 py-1.5 text-xs font-medium transition ${
                selected
                  ? "border-amber-500 bg-amber-50 text-amber-900"
                  : "border-slate-300 bg-white text-slate-600 hover:border-amber-300 hover:bg-amber-50/40"
              }`}
            >
              {itemLabel}
            </button>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className="md:col-span-2">
      <label
        className={`mb-3 block font-semibold ${designClasses.textPrimary}`}
      >
        {label}
      </label>

      <div className="space-y-5">
        {renderGroup(
          "General Hobbies",
          generalHobbyOptions
        )}

        {renderGroup(
          "Spiritual & Activities",
          spiritualActivityOptions
        )}
      </div>
    </div>
  );
};

export default FullWidthHobbiesGrid;
